<template>
    <div class="tools-container">
        <div class="tools-box">
            <el-tabs class="tool-el-tab" type="card" tab-position="left" v-model="tabActiveName" @tab-click="handleTabClick">
                <el-tab-pane v-for="item in toolsCategoryList" :key="item.id" :name="item.name">
                    <span slot="label" class="tool-tab-pane-label">
                        {{ item.name }}</span>
                </el-tab-pane>
                <!-- <el-tab-pane>
                  <span slot="label" class="tool-tab-pane-label">
                    <img :src="svgList[0]" alt="">
                    常用工具</span>
                </el-tab-pane> -->
              </el-tabs>
              <div class="tools-list-container">
                    <ToolsItem v-for="item in toolsList" :key="item.id" :tools-item="item" @toOhterSite="toOhterSite"></ToolsItem>
              </div>
        </div>
        <div class="contact-box">
            <Contact />
        </div>
    </div>
</template>

<script>
    import Contact from "@/components/Contact"
    import ToolsItem from "@/components/ToolsItem"
    import { getToolsList } from "@/api/home"
    const exampleSvg = require('@/assets/example.svg')
    const downloadSvg = require('@/assets/download.svg')
    const documentSvg = require('@/assets/document.svg')
    const videoSvg = require('@/assets/video.svg')
    export default {
        data() {
            return {
                tabActiveName:'操作后台',
                toolsCategoryList:[],
                svgList:[exampleSvg,downloadSvg,documentSvg,videoSvg],
                toolsList:[]
            }
        },
        components: { Contact,ToolsItem },
        async created() {
            window.scrollTo(0,0)
            await this.getToolsList()
        },
        methods:{
            toOhterSite(toolsItem) {
                if(toolsItem.link) {
                    window.open(toolsItem.link,'_blank')
                }
            },
            handleTabClick(tab) {
                const toolsContainerEle = document.getElementsByClassName('tools-container')[0]
                const rect = toolsContainerEle.getBoundingClientRect()
                if(rect.top < 10) {
                    window.scrollTo(0,10)
                }
                const temp = this.toolsCategoryList.find(item => item.name === tab.name)
                this.toolsList = temp ? temp.navigation : []
            },
            async getToolsList() {
                const res = await getToolsList()
                if(res.data) {
                    this.toolsCategoryList = res.data.map((item)=>{
                        return {
                            id:item.id,
                            name:item.name,
                            navigation:item.navigation
                        }
                    })
                    this.tabActiveName = this.toolsCategoryList[0].name
                    this.toolsList = this.toolsCategoryList[0].navigation
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/mixin.less";
    @import "~@/styles/var.less";
    .tools-container {
        position: relative;
        z-index: 50;
        scroll-behavior: smooth;
    }
    .tools-box {
        width: 1200px;
        margin: 25px auto 107px;
        display: flex;
    }
    /deep/ .el-tabs__item {
        height: 28px;
        line-height: 0;
        padding: 30px 27px;
        border: none !important;
        box-sizing: content-box;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    /deep/ .el-tabs__item.is-active { 
        border: none !important;
        background: #fff;
    }
    /deep/ .el-tabs__nav,
    /deep/ .el-tabs__header{
        border: none !important;
    }
    .el-tabs--left /deep/.el-tabs__header.is-left {
        margin-right: 0;
    }
    .tool-tab-pane-label{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 600;
        color: @words;
        > img {
            margin-right: 13px;
        }
    }
    .tools-list-container {
        width: 100%;
        padding: 30px 15px;
        display: flex;
        flex: 1;
        background: #fff;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        flex-wrap: wrap;
        /* 解决换行后间距过大 */
        align-content: flex-start; 
    }
    .contact-box {
        .contact-box()
    }
</style>
<style>
    .tool-el-tab {
        height: 680px;
    }
</style>